import { render, staticRenderFns } from "./DefaultResponses.vue?vue&type=template&id=0eb4eea5"
import script from "./DefaultResponses.vue?vue&type=script&lang=js"
export * from "./DefaultResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports